const filterLinksArray = document.querySelectorAll('.filtering-list__itemByValue');
const filterPriceLinksArray = document.querySelectorAll('.filtering-list__itemByPrice');
const currentWindowHeight = window.innerHeight;

function getPriceFromString(priceString) {
  let number = parseFloat(priceString.replace(/[^0-9,.]/g, '').replace('.', '').replace('$', ''));

  if (priceString.length <= 4) {
    number = `${number}00`;
  }

  return +number;
}

function filterFunctionality() {
  const filterTitle = document.querySelector('.collectionFullpage__filterTitle');
  const closeButtons = document.querySelectorAll('.collection-filtering__closeButton');
  const productPreviewLinks = document.querySelectorAll('.quick-add__sizes a');
  const applyFiltersButton = document.querySelector('.fullpageCollectionFilter__buttonApply');
  const cancelFiltersButton = document.querySelector('.fullpageCollectionFilter__buttonLink');

  if (filterTitle) {
    filterTitle.addEventListener('click', (e) => {
      e.preventDefault();
      openFilter();
    });

    filterTitle.addEventListener('keydown', (e) => {
      e.preventDefault();

      if (e.key === 13 || e.key === 'Enter') {
        openFilter(e);
      }
    });
  }

  closeButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      closeFilter();
    });
  });

  productPreviewLinks.forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      productPreviewLinkActive(event);
    });
  });

  if (applyFiltersButton) {
    applyFiltersButton.addEventListener('click', showFilteredProducts);
  }

  if (cancelFiltersButton) {
    cancelFiltersButton.addEventListener('click', clearFilters);
  }
}

filterLinksArray.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    createFilterArray(event);
  });
});

filterPriceLinksArray.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    createPriceFilterArray(event);
  });
});

function clearFilters() {
  const activeItemsArray = document.querySelectorAll('.collectionFullpage__filter .filtering-list__item--active');
  const activeCollectionFilter = document.querySelectorAll('.collectionSubcategories__filter-tags .filtering-list__item--active');
  const applyFiltersButton = document.querySelector('.fullpageCollectionFilter__buttonApply');

  activeItemsArray.forEach(item => {
    item.classList.remove('filtering-list__item--active');
  });

  activeCollectionFilter.forEach(item => {
    item.remove();
  });

  const collectionFilter = document.querySelector('collection-filter');
  if (collectionFilter && collectionFilter.clearURLFilters) {
    collectionFilter.clearURLFilters();
  }

  applyFiltersButton.click();
}

function productPreviewLinkActive(event) {
  const currentLink = event.currentTarget;
  const linkSizePicker = currentLink.closest('.quick-add__sizes');
  const linkSizePickerWrapper = currentLink.closest('.collectionFullpageProduct__contentFooter');
  const linksText = linkSizePickerWrapper.querySelectorAll('.collectionFullpageProduct__contentFooterButton span');
  const sizePickerActiveLink = linkSizePicker.querySelector('.quick-add__size--active');
  const sizePickerButton = linkSizePickerWrapper.querySelector('.collectionFullpageProduct__contentFooterButton');

  if (sizePickerActiveLink) {
    sizePickerActiveLink.classList.remove('quick-add__size--active');
    currentLink.classList.add('quick-add__size--active');
  } else {
    currentLink.classList.add('quick-add__size--active');
  }

  sizePickerButton.dataset.id = currentLink.dataset.id;
  sizePickerButton.dataset.inventoryQuantity = currentLink.dataset.inventoryQuantity;

  linksText.forEach(text => {
    text.dataset.inventoryQuantity = currentLink.dataset.inventoryQuantity;
    text.dataset.id = currentLink.dataset.id;
  });
};

function closeFilter() {
  const activeFilterList = document.querySelector('.collectionFullpage__filter.collectionFullpage__filter--active');
  const localOverlay = activeFilterList?.querySelector('.overlap.overlap--local');
  const overlay = localOverlay || document.querySelector('.overlap');
  const body = document.querySelector('body');

  if (activeFilterList) {
    overlay.classList.remove('overlap--active');
    body.classList.remove('body--overflow');
    activeFilterList.classList.remove('collectionFullpage__filter--active');
  }
};

function createFilterArray(event) {
  const currentLink = event.currentTarget;
  const currentFilterGroup = currentLink.closest('.filtering-group__item');
  const currentFilterGroupActive = currentFilterGroup.querySelector('.filtering-list__item--active');

  if (
    currentFilterGroupActive
    && !currentLink.classList.contains('filtering-list__item--active')
  ) {
    currentFilterGroupActive.classList.remove('filtering-list__item--active');
  }

  currentLink.classList.toggle('filtering-list__item--active');
  
  setTimeout(() => {
    const collectionFilter = document.querySelector('collection-filter');
    if (collectionFilter && collectionFilter.updateURLWithFilters) {
      collectionFilter.updateURLWithFilters();
    }
  }, 50);
};

function createPriceFilterArray(event) {
  const currentLink = event.currentTarget;
  const activeLink = document.querySelector('.collectionFullpage__filter .filtering-list__itemByPrice.filtering-list__item--active');

  if (currentLink.classList.contains('filtering-list__item--active')) {
    currentLink.classList.remove('filtering-list__item--active');
    setTimeout(() => {
      const collectionFilter = document.querySelector('collection-filter');
      if (collectionFilter && collectionFilter.updateURLWithFilters) {
        collectionFilter.updateURLWithFilters();
      }
    }, 50);
    return;
  }

  if (activeLink) {
    activeLink.classList.remove('filtering-list__item--active');
  }

  currentLink.classList.add('filtering-list__item--active');
  
  setTimeout(() => {
    const collectionFilter = document.querySelector('collection-filter');
    if (collectionFilter && collectionFilter.updateURLWithFilters) {
      collectionFilter.updateURLWithFilters();
    }
  }, 50);
};

window.updateURLWithFilters = function updateURLWithFilters() {
  const url = new URL(window.location);
  const activeFilterItems = document.querySelectorAll('.collectionFullpage__filter .filtering-list__item--active');
  
  const existingParams = Array.from(url.searchParams.keys());
  existingParams.forEach(param => {
    if (param.startsWith('filter_') || param === 'sort_by') {
      url.searchParams.delete(param);
    }
  });
  
  const filters = new Map();
  let sortValue = '';
  
  activeFilterItems.forEach(item => {
    const tagFilter = item.dataset.tagFilter;
    const value = item.dataset.value;
    const group = item.dataset.group;
    
    if (value && value.includes('?sort_by')) {
      const sortMatch = value.match(/sort_by=([^&]+)/);
      if (sortMatch) {
        sortValue = sortMatch[1];
      }
    } else if (tagFilter && group) {
      const tagParts = tagFilter.split(':');
      if (tagParts.length >= 3) {
        const filterValue = tagParts[2].replace('+', '').toLowerCase();
        
        if (!filters.has(group)) {
          filters.set(group, []);
        }
        filters.get(group).push(filterValue);
      }
    } else if (value && value.includes('size-')) {
      const sizeValue = value.replace('size-', '').replace('+', '');
      if (!filters.has('size')) {
        filters.set('size', []);
      }
      filters.get('size').push(sizeValue);
    }
  });
  
  filters.forEach((values, groupName) => {
    if (values.length > 0) {
      url.searchParams.set(`filter_${groupName}`, values.join(','));
    }
  });
  if (sortValue) {
    url.searchParams.set('sort_by', sortValue);
  }
  
  window.history.replaceState({}, '', url.toString());
}

async function showFilteredProducts() {
  let stringTags = '',
      activeFilterItems = document.querySelectorAll('.collectionFullpage__filter .filtering-list__item--active'),
      filterArray = [],
      sizeFiltering = [],
      currentPage = document.location.href,
      sortValue = '';

  activeFilterItems.forEach(item => {
    let currentTag = item.dataset.tagFilter ? item.dataset.tagFilter : item.dataset.value;

    if (currentTag.includes('size')) {
      sizeFiltering.push(currentTag.replace('+', ''));
    }

    if (filterArray.includes(currentTag)) {
      let sameTag = filterArray.indexOf(currentTag);
      filterArray.splice(sameTag, 1);
    } else {
      filterArray.push(currentTag);
    }
  });

  filterArray.forEach(tag => {
    if (!tag.includes('?sort_by')) {
      stringTags += tag;
    }
  });

  filterArray.forEach(tag => {
    if (tag.includes('?sort_by')) {
      stringTags += tag;
    }
  });

  if (stringTags.includes('sort_by')) {
    const priceSortIndex = stringTags.indexOf('price-');

    if (priceSortIndex !== -1) {
      const priceSortValue = stringTags.slice(priceSortIndex);

      sortValue = priceSortValue.includes('ascending') ? 'ascending' : 'descending';
    }
  }

  if (!stringTags.includes('sort_by')) {
    const defaultSort = document.querySelector('collection-filter')?.dataset.defaultSort;

    if (defaultSort) {
      stringTags = stringTags
        ? `${stringTags}?sort_by=${defaultSort}`
        : `?sort_by=${defaultSort}`;

      if (defaultSort.includes('price-')) {
        sortValue = defaultSort.includes('ascending') ? 'ascending' : 'descending';
      }
    }
  }

  const collectionFilter = document.querySelector('collection-filter');
  if (collectionFilter && collectionFilter.updateURLWithFilters) {
    collectionFilter.updateURLWithFilters();
  }

  try {
    const response = await fetch(`${currentPage.split('?')[0]}/${stringTags}`);

    if (response.ok) {
      const data = await response.text();
      const pageWrapper = document.querySelector('.collectionFullpage__list');
      const parser = new DOMParser();
      const collectionPage = parser.parseFromString(data, "text/html");
      let filteredProductsArray = Array.from(collectionPage.querySelectorAll('.product__wrapper:not(.spotlight)'));

      if (stringTags === '' && document.querySelector('.pagination__nextLink--hidden')) {
        document.querySelector('.pagination__nextLink').classList.remove('pagination__nextLink--hidden');
      }

      const loadMoreButton = document.querySelector('.pagination__nextLink');

      pageWrapper.innerHTML = '';

      if (stringTags !== '') {
        loadMoreButton?.classList.add('pagination__nextLink--hidden');
      }

      let filteredProducts = sizeFiltering.length
        ? filteredProductsArray.filter(product => sizeFiltering.some(tag => product.dataset.size.includes(tag)))
        : filteredProductsArray;

      if (sortValue) {
        filteredProducts = filteredProducts.sort((a, b) => {
          const priceA = a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
            ? getPriceFromString(a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
            : getPriceFromString(a.querySelector('.collectionFullpageProduct__price').innerText);
          const priceB = b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
            ? getPriceFromString(b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
            : getPriceFromString(b.querySelector('.collectionFullpageProduct__price').innerText);
          return priceB - priceA;
        });

        if (sortValue !== 'descending') {
          filteredProducts.reverse();
        }
      }

      const pageMarkup = filteredProducts.map(product => product.outerHTML).join('');

      if (pageMarkup && pageMarkup.length > 0) {
        pageWrapper.innerHTML = pageMarkup;
      } else {
        const emptyTitle = pageWrapper.dataset.emptyTitle;
        const emptySubtitle = pageWrapper.dataset.emptySubtitle;
        if (!emptyTitle || !emptySubtitle) {
          return;
        }
        pageWrapper.innerHTML = `
          <div class="collectionFullpage__empty">
            <h2 class="collectionFullpage__emptyTitle">${emptyTitle}</h2>
            <p class="collectionFullpage__emptySubtitle">${emptySubtitle}</p>
          </div>
        `;
      }

      if (
        collectionPage.querySelector('[data-all-pages]') &&
        parseInt(collectionPage.querySelector('[data-this-page]').value) <= parseInt(collectionPage.querySelector('[data-all-pages]').value)
      ) {
        const nextPaginationPage = collectionPage.querySelector('[data-next-link]').value;
        const nextStepPagination = parseInt(collectionPage.querySelector('[data-this-page]').value) + 1;
        collectionPage.querySelector('[data-this-page]').value = nextStepPagination;

        const nextResponse = await fetch(`${nextPaginationPage}`);

        if (nextResponse.ok) {
          const nextData = await nextResponse.text();
          const nextCollectionPage = parser.parseFromString(nextData, "text/html");
          const nextFilteredProductsArray = Array.from(nextCollectionPage.querySelectorAll('.product__wrapper:not(.spotlight)'));

          let nextFilteredProducts = sizeFiltering.length
            ? nextFilteredProductsArray.filter(product => sizeFiltering.some(tag => product.dataset.size.includes(tag)))
            : nextFilteredProductsArray;

          if (sortValue) {
            nextFilteredProducts = nextFilteredProducts.sort((a, b) => {
              const priceA = a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
                ? getPriceFromString(a.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
                : getPriceFromString(a.querySelector('.collectionFullpageProduct__price').innerText);
              const priceB = b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew')
                ? getPriceFromString(b.querySelector('.collectionFullpageProduct__contentHeaderPriceNew').innerText)
                : getPriceFromString(b.querySelector('.collectionFullpageProduct__price').innerText);
              return priceB - priceA;
            });

            if (sortValue !== 'descending') {
              nextFilteredProducts.reverse();
            }
          }

          const nextPageMarkup = nextFilteredProducts.map(product => product.outerHTML).join('');

          pageWrapper.insertAdjacentHTML('beforeend', nextPageMarkup);

          setTimeout(() => {
            const productsArray = document.querySelectorAll('.product__wrapper');

            productsArray.forEach((product, i) => {
              product.style.opacity = 1;
              product.style.transitionDelay = `1s`;
              product.classList.add('product__wrapper--active');
            });
          }, 1000);
        }
      }

      const activeFileters = document.querySelectorAll('.collectionFullpage__filter .filtering-list__item--active');
      const collectionSubcategoriesFilterTags = document.querySelector('.collectionSubcategories__filter-tags');

      if (collectionSubcategoriesFilterTags) {
        collectionSubcategoriesFilterTags.innerHTML = '';

        activeFileters.forEach((tag) => {
          collectionSubcategoriesFilterTags.innerHTML += tag.outerHTML;
        });
      }

      setTimeout(() => {
        fadeoutFunctionality();

        const productsArray = document.querySelectorAll('.product__wrapper');

        productsArray.forEach((product, i) => {
          product.style.opacity = 1;
          product.style.transitionDelay = `${i / 10}s`;
          product.classList.add('product__wrapper--active');
        });

        closeFilter();
      }, 1000);

      setTimeout(() => {
        addToCartFunctionlity();
        filterFunctionality();
      }, 3000);
    }
  } catch (error) {
    console.error("Error loading filtered products:", error);
  }
}

function isSafari() {
  return navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;
};

function openFilter() {
  const filterList = document.querySelector('.collectionFullpage__filter');
  const localOverlay = filterList?.querySelector('.overlap.overlap--local');
  const overlay = localOverlay || document.querySelector('.overlap');
  const body = document.querySelector('body');

  if (filterList) {
    filterList.classList.add('collectionFullpage__filter--active');
    overlay.classList.add('overlap--active');
    body.classList.add('body--overflow');
  }

  if (isSafari()) {
    if (
      currentWindowHeight == window.innerHeight
      || currentWindowHeight + 1 == window.innerHeight
    ) {
      document.documentElement.style.setProperty('--filters-height', `80px`);
    } else {
      document.documentElement.style.setProperty('--filters-height', `0px`);
    }
  }
};

function fadeoutFunctionality() {
  const collectionLinksArray = document.querySelectorAll('.collectionFullpage a:not(.quick-add__size)');

  function fadeout() {
    let collectionWrapper = document.querySelector('.wrapper');

    collectionWrapper.classList.add('wrapper--opacity');
  }

  collectionLinksArray.forEach(link => {
    link.addEventListener('click', fadeout);
  });
}

function restoreFiltersFromURL() {
  const url = new URL(window.location);
  
  const urlParams = url.searchParams;
  
  urlParams.forEach((value, key) => {
    if (key.startsWith('filter_')) {
      const filterType = key.replace('filter_', '');
      const filterValues = value.split(',');
      
        filterValues.forEach(filterValue => {
          const matchingFilters = document.querySelectorAll(`[data-group="${filterType}"]`);
          
          matchingFilters.forEach(filter => {
            const tagFilter = filter.dataset.tagFilter;
            if (tagFilter && tagFilter.toLowerCase().includes(filterValue.toLowerCase())) {
              filter.classList.add('filtering-list__item--active');
            }
          });

          const valueFilter = document.querySelector(`[data-value="${filterType}-${filterValue}+"]`);
          if (valueFilter) {
            valueFilter.classList.add('filtering-list__item--active');
          }
        });
    } else if (key === 'sort_by') {
      const sortFilter = document.querySelector(`[data-value="?sort_by=${value}"]`);
      if (sortFilter) {
        sortFilter.classList.add('filtering-list__item--active');
      }
    }
  });
  
  const hasActiveFilters = document.querySelectorAll('.collectionFullpage__filter .filtering-list__item--active').length > 0;
  if (hasActiveFilters) {
    setTimeout(() => {
      const applyButton = document.querySelector('.fullpageCollectionFilter__buttonApply');
      if (applyButton) {
        applyButton.click();
      }
    }, 100);
  }
}

filterFunctionality();
fadeoutFunctionality();

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', restoreFiltersFromURL);
} else {
  restoreFiltersFromURL();
}

if ((/iphone|ipod|ipad.*os 5/gi).test(navigator.appVersion)) {
  window.onpageshow = function(evt) {
    if (evt.persisted) {
      let collectionWrapper = document.querySelector('.wrapper');

      setTimeout(() => {
        collectionWrapper.classList.remove('wrapper--opacity');
      }, 1000);
    }
  };
}

(function() {
  const totalPages = parseInt(document.querySelector('[data-all-pages]')?.value);
  const currentPage = parseInt(document.querySelector('[data-this-page]')?.value);
  const current_page_new = currentPage + 1;

  if(isNaN(current_page_new) && isNaN(totalPages)) {
    document.querySelector('.collectionFullpage__link')?.remove();
  }
})();

const loadMoreObserver = new IntersectionObserver(async (entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      const totalPages = parseInt(document.querySelector('[data-all-pages]')?.value);
      const currentPage = parseInt(document.querySelector('[data-this-page]')?.value);
      const datacollurl = document.querySelector('[data-coll-url]').value;
      const nextLinkPagination = document.querySelector('.pagination__nextLink:not(.pagination__nextLink--hidden)');

      if (nextLinkPagination && totalPages && currentPage) {
        const nextUrl = document.querySelector('[data-next-link]').value;
        const current_page_new = currentPage + 1;
        const next_coll = currentPage + 2;

        try {
          const response = await fetch(nextUrl);
          const responseHTML = await response.text();
          const parser = new DOMParser();
          const responseDocument = parser.parseFromString(responseHTML, 'text/html');
          const nextProductsArray = responseDocument.querySelectorAll('.product__wrapper:not(.spotlight)');

          document.querySelector('[data-next-link]').value = `${datacollurl}?page=${next_coll}`;
          document.querySelector('[data-this-page]').value = current_page_new;

          const collectionList = document.querySelector('.collectionFullpage__list');

          nextProductsArray.forEach(product => {
            collectionList.appendChild(product.cloneNode(true));
          });

          setTimeout(() => {
            const products = document.querySelectorAll('.product__wrapper:not(.product__wrapper--active)');

            products.forEach((product, i) => {
              const delayTime = i / 10;
              product.style.transitionDelay = `${delayTime}s`;
              product.style.opacity = '1';
              product.classList.add('product__wrapper--active');
            });
          }, 1);

          if(current_page_new >= totalPages) {
            filterFunctionality();
            addToCartFunctionlity();
            fadeoutFunctionality();
          }
        } catch (error) {
          console.error('Error loading more products:', error);
        }
      }
    }
  }
}, {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
});

const nextLink = document.querySelector('.pagination__nextLink');

if (nextLink) {
  loadMoreObserver.observe(nextLink);
}

(function() {
  const collectionProductsArray = document.querySelectorAll('.product__wrapper');
  const spotlightsArray = document.querySelectorAll('.spotlight');

  async function addSpotlights() {
    spotlightsArray.forEach(spotlight => {
      let spotlightPosition = spotlight.dataset.position;

      if (spotlightPosition && collectionProductsArray[spotlightPosition]) {
        collectionProductsArray[spotlightPosition].insertAdjacentHTML("beforebegin", spotlight.outerHTML);
      }
    });

    await checkSpotlightsPosition();
    await scrollToSection();
  }

  async function checkSpotlightsPosition() {
    if (window.innerWidth <= 768) {
      const platesArray = document.querySelectorAll('.collectionFullpage__list .product__wrapper');

      platesArray.forEach((plate, index) => {
        if (plate.classList.contains('spotlight') && platesArray[index + 1].classList.contains('spotlight') && (index % 2 == 0)) {
          plate.classList.add('spotlight--marginZero');
          platesArray[index + 1].classList.add('spotlight--marginZero');
        }
      });
    }
  }

  async function scrollToSection() {
    const urlHash = window.location.hash;

    if (urlHash) {
      const targetSection = document.querySelector(`.${urlHash.slice(1)}`);

      if (targetSection) {
        const elementRect = targetSection.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);

        window.scrollTo({
          top: middle,
          behavior: 'smooth'
        });

        targetSection.focus({ preventScroll: true });
      }
    }
  }

  addSpotlights();
})();
